import { useTranslation } from "react-i18next";
// Components
import { HeaderMainDiv, HeaderDiv, Title } from "./styles";

const ActivitiesHeader = ({ title = "activities" }) => {
  const [t] = useTranslation("global");

  return (
    <HeaderMainDiv>
      <HeaderDiv>
        <Title width={"350px"}>{t(title).toUpperCase()}</Title>
        <Title width={"200px"} textAlign>
          {t("averageTime").toUpperCase()}
        </Title>
        <Title width={"200px"} textAlign>
          {t("AccumulatedTime").toUpperCase()}
        </Title>
        <Title width={"110px"} textAlign>
          {t("reports").toUpperCase()}
        </Title>
      </HeaderDiv>
    </HeaderMainDiv>
  );
};

export default ActivitiesHeader;
